export default state => state.geolocation.coordinates;
